import _ from 'underscore';
import Address from '../../models/Address';
var ExistingAddressesController = /** @class */ (function () {
    /*@ngInject*/
    function ExistingAddressesController($scope, $mdDialog, Util, AddressService) {
        this.shipAddressIdToDelete = null;
        this.selectedAddress = this.selectedAddress || new Address();
        this.selectedTab = 'business';
        this.errorGettingAddresses = false;
        this.$scope = $scope;
        this.$scope.selectedAddressId = this.selectedAddress.selectedAddressId;
        this.shipAddressIdToDelete = null;
        this.$mdDialog = $mdDialog;
        this.Util = Util;
        this.AddressService = AddressService;
        this.currentSearchTerm = '';
        this.addressPageModel = {
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            pages: [1]
        };
    }
    ExistingAddressesController.prototype.$onInit = function () {
        this.getAddress(1);
    };
    ExistingAddressesController.prototype.getAddress = function (pageNumber, searchTerm) {
        var _this = this;
        this.addressPageModel.currentPage = pageNumber;
        this.shippingAddresses = null;
        var getAddressFunction = this.isSelected('business')
            ? this.AddressService.getBusinessAddresses(pageNumber, this.addressPageModel.pageSize, searchTerm)
            : this.AddressService.getDropShipAddresses(pageNumber, this.addressPageModel.pageSize, searchTerm);
        this.Util.handleApiResponse(getAddressFunction, this, function (response) {
            _this.shippingAddresses = response.data.response.currentPage;
            _this.updateAddressPageModel(response.data.response);
            _this.Util.resetApiError(_this);
        }, function (response) { return _this.errorGettingAddresses = true; });
    };
    ExistingAddressesController.prototype.updateAddressPageModel = function (response) {
        // calculate total pages
        this.addressPageModel.totalPages = Math.ceil(response.totalResults / this.addressPageModel.pageSize);
        this.addressPageModel.pages = _.range(1, this.addressPageModel.totalPages + 1);
    };
    ExistingAddressesController.prototype.addressPageChanged = function () {
        this.getAddress(this.addressPageModel.currentPage, this.currentSearchTerm);
    };
    ExistingAddressesController.prototype.findPatientAddress = function (evt, searchTerm, pageNumber, clear) {
        var clickOrEnter = evt && (evt.key == 'Enter' || evt.type == 'click');
        if (!clickOrEnter && !clear)
            return;
        this.currentSearchTerm = searchTerm;
        this.getAddress(pageNumber, searchTerm);
    };
    ExistingAddressesController.prototype.deleteShippingAddress = function (shippingAddress) {
        var _this = this;
        this.Util.handleApiResponse(this.AddressService.deleteAddress(shippingAddress.addressId), this, function (response) {
            var filter = function (x) { return x.addressId != shippingAddress.addressId; };
            _this.shippingAddresses = _this.shippingAddresses.filter(filter);
        });
    };
    ExistingAddressesController.prototype.selectRow = function (address) {
        if (this.AddressService.isValidShippingCountries(address.countryCode)) {
            var previouslySelected = this.selectedAddress && this.selectedAddress.addressId == address.addressId;
            this.selectedAddress = previouslySelected ? null : address;
            this.$mdDialog.hide({ address: this.selectedAddress });
        }
    };
    ExistingAddressesController.prototype.getDisplayAddress = function (shippingAddress) {
        var address = shippingAddress.line1;
        if (shippingAddress.line2 && shippingAddress.line2 != '')
            address += ' ' + shippingAddress.line2;
        address += ', ' + shippingAddress.city + ', ';
        if (shippingAddress.regionName)
            address += shippingAddress.regionName;
        if (shippingAddress.postalCode.length == 9)
            address += ' ' + shippingAddress.postalCode.substr(0, 5) + '-' + shippingAddress.postalCode.substr(5);
        else
            address += ' ' + shippingAddress.postalCode;
        return address + ' ' + shippingAddress.countryCode;
    };
    ExistingAddressesController.prototype.isRowSelected = function () {
        return this.selectedAddress == null ? false : true;
    };
    ExistingAddressesController.prototype.selectTab = function (tab) {
        if (tab == this.selectedTab)
            return;
        this.currentSearchTerm = this.findAddress = '';
        this.selectedTab = tab;
        this.getAddress(1);
    };
    ExistingAddressesController.prototype.isSelected = function (tab) {
        return tab === this.selectedTab;
    };
    ExistingAddressesController.prototype.hide = function () {
        this.$mdDialog.hide();
    };
    ExistingAddressesController.prototype.closeAlert = function () {
        this.$mdDialog.hide();
    };
    ExistingAddressesController.prototype.cancel = function () {
        this.$mdDialog.cancel();
    };
    ExistingAddressesController.prototype.answer = function (answer) {
        this.$mdDialog.hide();
    };
    return ExistingAddressesController;
}());
export default ExistingAddressesController;
//# sourceMappingURL=existing-address.controller.js.map